import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Privacidade from "./pages/Privacidade";
import Termos from "./pages/Termos";
import Trial from "./pages/Trial";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
function App() {
  return (
    <div className="App anjora-bg">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacidade" element={<Privacidade />} />
          <Route path="/termos" element={<Termos />} />
          <Route path="/trial" element={<Trial />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}
export default App;